module.exports = __webpack_public_path__ + "img/tractor-panel.67cd65e3.jpeg";